import React = require('react');
import { Button } from 'react-bootstrap';

interface IAdmiralPartnerOfferCard {
  image: any,
  contentText: any,
  buttonText: string,
  redirectUrl: string,
  buttonMarginTop: string
}

export const PartnerOfferCard = ({ image, contentText, buttonMarginTop, buttonText, redirectUrl }: IAdmiralPartnerOfferCard) => {

  const redirectOnClick = () => {
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  }

  return (
    <div className={'offer-card offer-card-partner'}>

      <img src={image} alt={''}/>

      <div className={'content'}>

        <div className={'text'}>{contentText}</div>

        <Button
          style={{ marginTop: buttonMarginTop }}
          className="partner-button"
          onClick={redirectOnClick}
        >{buttonText}
        </Button>

      </div>

    </div>
  );

}
